/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
	name: "ProgressRing",
	props: {
		primary: String,
		secondary: String,
		radius: Number,
		progress: Number,
		stroke: Number
	},
	data() {
		const normalizedRadius = this.radius - this.stroke * 2;
		const circumference = normalizedRadius * 2 * Math.PI;

		return {
			normalizedRadius,
			circumference
		};
	},
	computed: {
		strokeDashoffset() {
			return (
				this.circumference - (this.progress / 100) * this.circumference
			);
		}
	}
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { attrs: { height: _vm.radius * 2, width: _vm.radius * 2 } },
    [
      _c("circle", {
        style: {
          stroke: _vm.secondary,
          strokeDashoffset: 0
        },
        attrs: {
          "stroke-dasharray": _vm.circumference + " " + _vm.circumference,
          "stroke-width": _vm.stroke,
          fill: "transparent",
          r: _vm.normalizedRadius,
          cx: _vm.radius,
          cy: _vm.radius
        }
      }),
      _vm._v(" "),
      _c("circle", {
        style: {
          stroke: _vm.primary,
          strokeDashoffset: _vm.strokeDashoffset
        },
        attrs: {
          "stroke-dasharray": _vm.circumference + " " + _vm.circumference,
          "stroke-width": _vm.stroke,
          fill: "transparent",
          r: _vm.normalizedRadius,
          cx: _vm.radius,
          cy: _vm.radius
        }
      }),
      _vm._v(" "),
      _c(
        "text",
        {
          style: {
            color: "var(--text-color)",
            fontSize: "var(--text-xs)",
            fontWeight: "var(--text-bold)"
          },
          attrs: {
            "dominant-baseline": "middle",
            "text-anchor": "middle",
            x: _vm.radius,
            y: _vm.radius
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.progress) + "%\n\t")]
      )
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-0f538d8f_0", { source: "\ncircle[data-v-0f538d8f] {\n\ttransition: stroke-dashoffset 0.35s;\n\ttransform: rotate(-90deg);\n\ttransform-origin: 50% 50%;\n}\n", map: {"version":3,"sources":["frappe/public/js/frappe/file_uploader/ProgressRing.vue"],"names":[],"mappings":";AAsEA;CACA,mCAAA;CACA,yBAAA;CACA,yBAAA;AACA","file":"ProgressRing.vue","sourcesContent":["<template>\n\t<svg :height=\"radius * 2\" :width=\"radius * 2\">\n\t\t<circle\n\t\t\t:stroke-dasharray=\"circumference + ' ' + circumference\"\n\t\t\t:style=\"{\n\t\t\t\tstroke: secondary,\n\t\t\t\tstrokeDashoffset: 0\n\t\t\t}\"\n\t\t\t:stroke-width=\"stroke\"\n\t\t\tfill=\"transparent\"\n\t\t\t:r=\"normalizedRadius\"\n\t\t\t:cx=\"radius\"\n\t\t\t:cy=\"radius\"\n\t\t/>\n\t\t<circle\n\t\t\t:stroke-dasharray=\"circumference + ' ' + circumference\"\n\t\t\t:style=\"{\n\t\t\t\tstroke: primary,\n\t\t\t\tstrokeDashoffset: strokeDashoffset\n\t\t\t}\"\n\t\t\t:stroke-width=\"stroke\"\n\t\t\tfill=\"transparent\"\n\t\t\t:r=\"normalizedRadius\"\n\t\t\t:cx=\"radius\"\n\t\t\t:cy=\"radius\"\n\t\t/>\n\t\t<text\n\t\t\tdominant-baseline=\"middle\"\n\t\t\ttext-anchor=\"middle\"\n\t\t\t:x=\"radius\"\n\t\t\t:y=\"radius\"\n\t\t\t:style=\"{\n\t\t\t\tcolor: 'var(--text-color)',\n\t\t\t\tfontSize: 'var(--text-xs)',\n\t\t\t\tfontWeight: 'var(--text-bold)'\n\t\t\t}\"\n\t\t>\n\t\t\t{{ progress }}%\n\t\t</text>\n\t</svg>\n</template>\n<script>\nexport default {\n\tname: \"ProgressRing\",\n\tprops: {\n\t\tprimary: String,\n\t\tsecondary: String,\n\t\tradius: Number,\n\t\tprogress: Number,\n\t\tstroke: Number\n\t},\n\tdata() {\n\t\tconst normalizedRadius = this.radius - this.stroke * 2;\n\t\tconst circumference = normalizedRadius * 2 * Math.PI;\n\n\t\treturn {\n\t\t\tnormalizedRadius,\n\t\t\tcircumference\n\t\t};\n\t},\n\tcomputed: {\n\t\tstrokeDashoffset() {\n\t\t\treturn (\n\t\t\t\tthis.circumference - (this.progress / 100) * this.circumference\n\t\t\t);\n\t\t}\n\t}\n};\n</script>\n<style scoped>\ncircle {\n\ttransition: stroke-dashoffset 0.35s;\n\ttransform: rotate(-90deg);\n\ttransform-origin: 50% 50%;\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-0f538d8f"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "<template>\n\t<svg :height=\"radius * 2\" :width=\"radius * 2\">\n\t\t<circle\n\t\t\t:stroke-dasharray=\"circumference + ' ' + circumference\"\n\t\t\t:style=\"{\n\t\t\t\tstroke: secondary,\n\t\t\t\tstrokeDashoffset: 0\n\t\t\t}\"\n\t\t\t:stroke-width=\"stroke\"\n\t\t\tfill=\"transparent\"\n\t\t\t:r=\"normalizedRadius\"\n\t\t\t:cx=\"radius\"\n\t\t\t:cy=\"radius\"\n\t\t/>\n\t\t<circle\n\t\t\t:stroke-dasharray=\"circumference + ' ' + circumference\"\n\t\t\t:style=\"{\n\t\t\t\tstroke: primary,\n\t\t\t\tstrokeDashoffset: strokeDashoffset\n\t\t\t}\"\n\t\t\t:stroke-width=\"stroke\"\n\t\t\tfill=\"transparent\"\n\t\t\t:r=\"normalizedRadius\"\n\t\t\t:cx=\"radius\"\n\t\t\t:cy=\"radius\"\n\t\t/>\n\t\t<text\n\t\t\tdominant-baseline=\"middle\"\n\t\t\ttext-anchor=\"middle\"\n\t\t\t:x=\"radius\"\n\t\t\t:y=\"radius\"\n\t\t\t:style=\"{\n\t\t\t\tcolor: 'var(--text-color)',\n\t\t\t\tfontSize: 'var(--text-xs)',\n\t\t\t\tfontWeight: 'var(--text-bold)'\n\t\t\t}\"\n\t\t>\n\t\t\t{{ progress }}%\n\t\t</text>\n\t</svg>\n</template>\n<script>\nexport default {\n\tname: \"ProgressRing\",\n\tprops: {\n\t\tprimary: String,\n\t\tsecondary: String,\n\t\tradius: Number,\n\t\tprogress: Number,\n\t\tstroke: Number\n\t},\n\tdata() {\n\t\tconst normalizedRadius = this.radius - this.stroke * 2;\n\t\tconst circumference = normalizedRadius * 2 * Math.PI;\n\n\t\treturn {\n\t\t\tnormalizedRadius,\n\t\t\tcircumference\n\t\t};\n\t},\n\tcomputed: {\n\t\tstrokeDashoffset() {\n\t\t\treturn (\n\t\t\t\tthis.circumference - (this.progress / 100) * this.circumference\n\t\t\t);\n\t\t}\n\t}\n};\n</script>\n<style scoped>\ncircle {\n\ttransition: stroke-dashoffset 0.35s;\n\ttransform: rotate(-90deg);\n\ttransform-origin: 50% 50%;\n}\n</style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__